import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { RxListPhotoItemComponent } from '../rx-list-photo-item';
import { Bundle, Pair, PairGif, Roles } from '@nrwl/rx-models';
import { SelectionManagerService, PAIR_SELECTION } from '@nrwl/rx-service-selection-manager';
import { RxGalleryService } from '../../rx-gallery/services/gallery.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { RxRoleGuardDirective } from '@org/rx-directives';
import { RxIconComponent } from '../../rx-icon/rx-icon.component';

@Component({
  selector: 'rx-list-bundle-item',
  templateUrl: './rx-list-bundle-item.component.html',
  styleUrls: ['./rx-list-bundle-item.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RxIconComponent,
    MatMenuModule,
    MatCheckboxModule,
    RxRoleGuardDirective,
  ],
})
export class RxListBundleItemComponent
  extends RxListPhotoItemComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() bundle;

  @Input()
  public showCheckbox = false;

  public previewItem: any;

  @Input()
  public rejectedRoles: Roles[] = [];

  public proportionalHeight: number;
  private resizeObserver: ResizeObserver;

  @HostListener('window:resize', ['$event.target'])
  public onResize() {
    this.recalculateHeight();
  }

  constructor(
    private _changeDetection: ChangeDetectorRef,
    public galleryService: RxGalleryService,
    @Inject(PAIR_SELECTION)
    private _pairManageService: SelectionManagerService<Pair | PairGif | Bundle>,
    private _el: ElementRef,
  ) {
    super(_changeDetection);
  }

  ngOnChanges(changes: SimpleChanges | any): void {
    if (changes['bundle']) {
      this.previewItem = this.galleryService.getPreviewImage(this.bundle.image_pairs[0]);
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.resizeObserver?.disconnect();
  }

  public override ngOnInit() {
    this._pairManageService.deselectAll_$.subscribe((res) => this._changeDetection.markForCheck());
  }
  public ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.recalculateHeight();
      this._changeDetection.markForCheck();
    });
    this.resizeObserver.observe(this._el.nativeElement);
  }

  public recalculateHeight() {
    this.proportionalHeight = this._el.nativeElement.getBoundingClientRect().width / 1.5;
  }

  imgErrorHandler(event) {
    event.target.src = 'assets/images/empty-img.svg';
  }
}
